export const AUTHORIZATION_HEADER_VALUE_PREFIX = 'Bearer';
